import { createSelector, Selector } from 'reselect';
import { State } from '../../reducers';
import { selectUser } from './user.selector';
import { CustomPriceList } from '../../../domain/Account';

export const selectAccountCustomPriceLists: Selector<State, CustomPriceList[]> = createSelector(
  [selectUser],
  (user) => user?.account.customPriceLists || [{ id: 'ERR !', title: 'ERR !', customPrices: [] }]
);
